export default {"src":"/_next/static/media/history.7d7589b1.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};